import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Globals } from './globals';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Policy } from 'app/models/policy';

@Injectable({ providedIn: 'root' })
export class PolicyService {

    constructor(private http: HttpClient, private globals: Globals, 
                private formBuilder: FormBuilder) {
    }

    getAll() {
        return this.http.get<Policy[]>(`${this.globals.api_base_url}/policies`);
    }

    getAllExternal() {
        return this.http.get<Policy[]>(`${this.globals.api_base_url}/policies/external`);
    }

    getById(id: number) {
        return this.http.get<Policy>(`${this.globals.api_base_url}/policy/${id}`);
    }

    putPolicy(policy: Policy) {
        return this.http.put<Policy>(`${this.globals.api_base_url}/policy`, policy);
    }

    deletePolicy(id: number) {
        return this.http.delete(`${this.globals.api_base_url}/policy/${id}`);
    }

    formGroup(policy: Policy = null){
        let frmGrp: FormGroup = this.formBuilder.group({
            id: [(policy)? policy.id: null],
            name: [(policy)? policy.name: '', [Validators.required, Validators.maxLength(255)]],
            is_external:[(policy)? policy.is_external: false],
            users: [(policy && policy.users)? policy.users: [], []],
            teams: [(policy && policy.teams)? policy.teams: [], []],
            workflow_names: [(policy && policy.workflow_names)? policy.workflow_names: [], []],
            permissions: [(policy && policy.permissions)? policy.permissions: [], []]
        });

        return frmGrp;
    }
}